import Entity from "./entity";
import Customer from "./customer";

class PriceList extends Entity {
  constructor(data) {
    super(data);

    this.customer = data.customer ? new Customer(data.customer) : null;
    this.validFrom = this.convertDate(data.validFrom);
    this.validTo = this.convertDate(data.validTo);

    this.value = data.id;
  }
}

export default PriceList;



// WEBPACK FOOTER //
// ./client/domain/priceList.js